/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_About_CtaInputs */

const ja_playdata_home_about_cta = /** @type {(inputs: Playdata_Home_About_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAについて`)
};

const en_playdata_home_about_cta = /** @type {(inputs: Playdata_Home_About_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Playdata_Home_About_CtaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_about_cta = /** @type {((inputs?: Playdata_Home_About_CtaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_About_CtaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_about_cta(inputs)
	return en_playdata_home_about_cta(inputs)
});